import React from 'react'

// Components
import ServicesStandard from 'components/flex/Services/ServicesStandard'

interface ServicesShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location?: any
}

interface PostProps {
  [key: string]: any
}

const ServicesShell: React.FC<ServicesShellProps> = ({
  fields,
  location = {},
}) => {
  const types: PostProps = {
    standard: ServicesStandard,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default ServicesShell
